import React from 'react';
import { Line } from 'react-chartjs-2';
import moment from 'moment';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, TimeScale } from 'chart.js';
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  TimeScale,
  Title,
  Tooltip,
  Legend
);


const FatigueChart = ({ data }) => {
  const chartData = {
    labels: data.map(journal => moment(journal.date).format('DD/MM/YYYY')),
    datasets: [{
      label: 'Fatigue',
      data: data.map(journal => {
        switch (journal.fatigue) {
          case 'Super high': return 5;
          case 'High': return 4;
          case 'Normal': return 3;
          case 'No fatigue	': return 2;
          case 'Super fresh': return 1;
          default: return null;
        }
      }),
      fill: false,
      borderColor: 'rgb(178, 34, 34)',
      tension: 0.1,
      cubicInterpolationMode: 'monotone'
    }],
  };

  const options = {
    spanGaps: true,
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
    },
    scales: {
      y: {
        title: {
          display: true,
          text: 'Fatigue',
        },
        min: 1,
        max: 5,
        ticks: {
          callback: function(value, index, values) {
            switch (value) {
              case 5: return 'Super high';
              case 4: return 'High';
              case 3: return 'Normal';
              case 2: return 'No fatigue';
              case 1: return 'Super fresh';
              default: return '';
            }
          }
        }
      },
      x: {
        title: {
          display: true,
          text: 'Date',
        }
      }
    }
  };

  return (
    <div className="p-4 bg-white rounded-lg shadow-lg">
      <Line data={chartData} options={options} />
    </div>
  );
};

export default FatigueChart;
